import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Team } from '../../models/team';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-team-card',
  templateUrl: './team-card.component.html',
  styleUrls: ['./team-card.component.scss'],
  animations: [
    trigger('expandCollapseHeader', [
      state('expanded', style({ 'border-bottom-left-radius': 0, 'border-bottom-right-radius': 0 })),
      state('collapsed', style({ 'border-bottom-left-radius': 'inherit', 'border-bottom-right-radius': 'inherit' })),
      transition('expanded <=> collapsed', animate('200ms ease-in-out')),
    ]),
    trigger('expandCollapse', [
      state('expanded', style({ height: '*', opacity: 1, overflow: 'hidden', padding: '*' })),
      state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden', 'padding-top': 0, 'padding-bottom': 0 })),
      transition('expanded <=> collapsed', animate('200ms ease-in-out')),
    ])
  ]
})
export class TeamCardComponent implements OnInit {

  @Input() team: Team;

  @Input() expanded = false;
  @Input() accordion = true;

  @Output() edit = new EventEmitter<Team>();
  @Output() delete = new EventEmitter<Team>();

  constructor() { }

  ngOnInit(): void {
  }

  toggleAccordion() {
    if (this.accordion) {
      this.expanded = !this.expanded;
    }
  }
}
